(function () {
    'use strict';

    angular
        .module('languageControllers', [])
        .directive('govLanguageSwitcher', ['languageService', function (languageService) {
            return {
                restrict: 'A',
                template:
                    '<a class="gov-lang-toggle" style="height:40px;cursor:pointer;">' +
                    '  <i class="fa fa-globe fa-2x" style="vertical-align:middle"></i> ' +
                    '  <span class="gov-lang-label"></span>&nbsp;' +
                    '  <span class="caret"></span>' +
                    '</a>' +
                    '<ul class="gov-lang-menu dropdown-menu" style="display:none;position:fixed;z-index:9999;"></ul>',
                link: function (scope, element) {
                    var languages = languageService.getAvailableLanguages();
                    var current = languageService.getCurrentLanguage();
                    var toggle = element[0].querySelector('.gov-lang-toggle');
                    var label = element[0].querySelector('.gov-lang-label');
                    var menu = element[0].querySelector('.gov-lang-menu');

                    // Set current label
                    label.textContent = current.label;

                    // Build menu items
                    languages.forEach(function (lang) {
                        var li = document.createElement('li');
                        if (lang.id === current.id) li.className = 'active';
                        var a = document.createElement('a');
                        a.style.cssText = 'display:block;padding:5px 20px;color:#333;cursor:pointer;';
                        a.textContent = lang.label;
                        if (lang.id === current.id) {
                            var icon = document.createElement('i');
                            icon.className = 'fa fa-check pull-right';
                            a.appendChild(icon);
                        }
                        a.addEventListener('click', function (e) {
                            e.stopPropagation();
                            if (lang.id !== current.id) {
                                languageService.setLanguage(lang.id);
                            }
                        });
                        li.appendChild(a);
                        menu.appendChild(li);
                    });

                    // Toggle on click
                    toggle.addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        var isOpen = menu.style.display !== 'none';
                        if (isOpen) {
                            menu.style.display = 'none';
                        } else {
                            var rect = toggle.getBoundingClientRect();
                            menu.style.top = rect.bottom + 'px';
                            menu.style.left = rect.left + 'px';
                            menu.style.display = 'block';
                        }
                    });

                    // Close on outside click
                    function closeMenu() { menu.style.display = 'none'; }
                    document.addEventListener('click', closeMenu);
                    menu.addEventListener('click', function (e) { e.stopPropagation(); });

                    scope.$on('$destroy', function () {
                        document.removeEventListener('click', closeMenu);
                    });
                }
            };
        }]);
})();
